import React from "react";
import {
  Grid,
  Box,
//   isWidthUp,
  Typography,
} from "@material-ui/core";



function TermsPrivacyHelper(props) {
  const { data } = props;
  return data.sections.map((section, index) => (
    <Grid key={index} item>
      <Grid key={index} item xs={12}>
        {renderPrivacySection(section)}
      </Grid>
    </Grid>
  ));
}

function renderPrivacySection(section) {
  return (
    <>
      <Box mb={3}>
        <Typography  align="center"  variant="h5">{section.title}</Typography>
        {section.data.map((item, index) => (
          <div key={index}>{renderPrivacyItem(item)}</div>
        ))}
      </Box>
    </>
  );
}

function createMarkup(txt) {
  return { __html: txt };
}

function renderPrivacyItem(item) {
  return (
    <>
      <Typography variant="h6" color="textSecondary">
        {item.title}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        <div dangerouslySetInnerHTML={createMarkup(item.text)} />
      </Typography>

      <ul>
        {item.list &&
          item.list.map((li, index) => (
            <li key={index}>
              <Typography variant="body2" color="textSecondary">
                <div dangerouslySetInnerHTML={createMarkup(li.text)} />
              </Typography>
            </li>
          ))}
      </ul>
    </>
  );
}


export default TermsPrivacyHelper;
